<template>
    <form @submit.prevent="submit">
        <div v-if="this.order">Cambia el orden en que aparecen los Hitos de Vida pulsando el botón 'Ordenar'.</div>
        <div v-if="this.order" class="text-right">
            <a v-if="!sorting" class="btn btn-primary" @click.prevent="show_sort">Ordenar</a>
            <button v-if="sorting" class="btn btn-primary" type="submit">Guardar</button>
        </div>
        <table class="table">
            <thead>
            <tr>
                <th>Título Hito</th>
                <th v-if="!deleted">Creador y Fecha Creación</th>
                <th v-if="deleted">Fecha Eliminación</th>
                <th>Acciones</th>
                <th v-if="sorting">Orden</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(h,index) in data">
                <td>{{h.title}}</td>
                <td v-if="!deleted">{{ h.user.first_name + ' ' + h.user.last_name }} {{ moment(h.created_at).format('DD-MM-YYYY')}}</td>
                <td v-if="deleted">{{ moment(h.deleted_at).format('DD-MM-YYYY LT')}}</td>
                <td>
                    <a v-if="!deleted" :href="'backend/hito-vida/'+h.id+'/edit'"><i class="material-icons">edit</i></a>
                    <a v-if="!deleted" href="#" @click.prevent="remove(h.id)"><i class="material-icons">delete</i></a>
                    <a v-if="deleted" :href="'backend/hito-vida/'+h.id+'/restore'">Restaurar</a>
                </td>
                <td v-if="sorting">
                    <a href="#" @click.prevent="up(index)"><i class="material-icons">arrow_upward</i></a>
                    <a href="#" @click.prevent="down(index)"><i class="material-icons">arrow_downward</i></a>
                </td>
            </tr>
            </tbody>
        </table>
        <div v-if="sorting" class="text-right">
            <button class="btn btn-primary" type="submit">Guardar</button>
        </div>
    </form>    
</template>
<script>
    import Vue from 'vue';
    import { Message, Confirm } from 'element-ui';

    export default{
        data: function(){
            return {
                data: _.cloneDeep(this.hitosvida),
                sorting: false,
                csrfToken: null,
                errors: {}
            }
        },
        props: ['hitosvida', 'order', 'deleted'],
        created() {
            this.csrfToken = document.querySelector('meta[name="csrf-token"]').content;
        },
        methods:{
            show_sort: function(){
                this.sorting = true;
            },
            moment: function(date){
                return moment(date);
            },
            remove: function(id){
                var self = this;
                self.$confirm('¿Está seguro de eliminar el registro?', 'Atención', {
                    confirmButtonText: 'Eliminar',
                    cancelButtonText: 'Cancelar',
                    type: 'warning'
                }).then(() => {
                    axios.delete('backend/hito-vida/'+id)
                    .then(function(response){
                        window.location.replace(response.data.redirect);
                    }).catch(function(error){
                        console.log(error);
                        self.$message.error('Ocurrió un error al intenter eliminar el registro.');
                    });                   
                }).catch(() => {
                    self.$message({
                        type: 'info',
                        message: 'Eliminación cancelada'
                    });
                });                               
            },
            up: function(from){
                if(from == 0)
                    return;

                var to = from - 1;
                this.data.splice(to, 0, this.data.splice(from, 1)[0]);
            },
            down: function(from){
                var to = from + 1;
                this.data.splice(to, 0, this.data.splice(from, 1)[0]);
            },
            submit: function(){
                var self = this;

                self.sorting = false;

                var output = {
                    hitosvida: this.data.map(function(d, index){
                        return {
                            id: d.id,
                            order: index
                        }
                    })
                };

                axios.put('backend/hito-vida/orden',output)
                    .then(function(response){
                        window.location.replace(response.data.redirect);
                    }).catch(function(error){
                        self.errors = error.response.data.errors;
                });
            }
        }
    }
</script>